import React, { useCallback, useEffect, useState } from 'react'
import { createMessage } from '../../utilities/utilities';
import { Container } from 'react-bootstrap';
import { handleError } from '../../utilities/errorHandler';
import {addSchedule, allSchedules, oneSchedule, removeSchedule, updateSchedule} from './../../services/schedules';
import CustomLoader from '../shared/CustomLoader';
import SchedulesTable from '../tables/SchedulesTable';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import ScheduleForm from '../forms/ScheduleForm';

const Schedules = () => {
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({
        text: '',
        variant: '',
        show: false
    });

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const [schedules, setSchedules] = useState([]);
    const [schedule, setSchedule] = useState(null);

    const getSchedules = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await allSchedules();
            if (response.status === 200){
                setSchedules(response.data);
            }
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getSchedules();
    }, [getSchedules]);

    const getSchedule = (id) => {
        oneSchedule(id).then((response) => {
            if (response.status === 200){
                setSchedule(response.data);
            }
        }).catch(error => {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        });
    }

    const deleteSchedule = (id) => {
        try {
            removeSchedule(id);
            handleMessage('Schedule successfully deleted', 'success');
            getSchedules();
        } catch (error) {
            const errorMessage = handleError(error);
            if (errorMessage){
                handleMessage(errorMessage.text, 'danger');
            }
        }
    }

    const saveSchedule = async (data) => {
        setIsSaving(true);
        try {
            const scheduleData = {
                site_id: data.site.value,
                shift_id: data.shift.value,
                officer_id: data.officer.value,
                start_date: data.start_date,
                end_date: data.end_date
            };

            if (data.id){
                await updateSchedule(data.id, scheduleData);
                handleMessage('Schedule succesfully updated', 'success');
                getSchedules();

                return true;
            } else {
                await addSchedule(scheduleData);
                handleMessage('Schedule successfully saved', 'success');
                getSchedules();

                return true;
            }
        } catch (error) {
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch (e) {
                // error 422 to be handled by onSubmit() in ScheduleForm.jsx 
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }

  return (
    <Container fluid>

        <PageTitle title='Schedule Details' />

        <Message
            message={message.text}
            show={message.show}
            handleClose={handleCloseMessage}
            variant={message.variant}
        />

        <ScheduleForm
            isSaving={isSaving}
            formAction={saveSchedule}
            schedule={schedule}
        />

        {
            isLoading ? (
                <CustomLoader />
            ) : (
                <SchedulesTable
                    schedules={schedules}
                    onEdit={getSchedule}
                    onDelete={deleteSchedule}
                />
            )
        }
    </Container>
  )
}

export default Schedules